<script lang="ts">
  import { supportsPlugins } from "@/config";
  import { routeHref } from "@/router";

  const { id, core, section }: { id: string; core: string; section: string } = $props();
  const links = $derived([
    { section: "home", route: "server-home" as const, label: "Обзор" },
    { section: "console", route: "server-console" as const, label: "Консоль" },
    { section: "files", route: "server-files" as const, label: "Файлы" },
    { section: "backups", route: "server-backups" as const, label: "Копии" },
    {
      section: "plugins",
      route: "server-plugins" as const,
      label: supportsPlugins(core) ? "Плагины" : core === "vanilla" ? "Расширения" : "Моды",
    },
    { section: "ai", route: "server-ai" as const, label: "Помощник" },
    { section: "settings", route: "server-settings" as const, label: "Настройки" },
  ]);
</script>

<nav class="server-tabs" aria-label="Разделы сервера">
  {#each links as link (link.section)}
    <a
      href={routeHref(link.route, { id })}
      aria-current={section === link.section ? "page" : undefined}>{link.label}</a
    >
  {/each}
</nav>

<style>
  .server-tabs {
    display: grid;
    grid-template-columns: repeat(7, minmax(0, 1fr));
    gap: 1px;
    margin-bottom: 1.5rem;
    border: 1px solid var(--line);
    background: var(--line);
  }
  a {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 48px;
    padding: 0.9rem 0.5rem;
    color: var(--muted);
    background: var(--surface);
    font: 600 0.75rem/1.4 var(--font-display);
    text-decoration: none;
  }
  a:hover {
    color: var(--cream);
    background: var(--surface-raised);
  }
  a[aria-current="page"] {
    color: var(--white);
    background: rgb(214 75 50 / 0.16);
    box-shadow: inset 0 -2px var(--mars-light);
  }
  @media (max-width: 640px) {
    .server-tabs {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }
    a:last-child {
      grid-column: 1 / -1;
    }
  }
</style>
